import React, { useState } from "react";
import {
  OpeniningCaseFile,
  OpeniningCaseFileStatus,
  Suspect,
  Witness,
} from "types";
import { DateView } from "utils/helper";
// import FeedbackSection from "./FeedbackSection";
import ImageModal from "components/ImageModal";
import SuspectDetailInfo from "pages/Incident/IncidentDetail/modals/SuspectDetailInfo";
import { viewIcon } from "utils/constant";

type Props = {
  file?: OpeniningCaseFile;
};

const CourtInfo: React.FC<Props> = ({ file }) => {
  const [selectedEntity, setSelectedEntity] = useState<Suspect>();
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState({
    suspect: false,
    witness: false,
  });

  const buildView = (data: Suspect | Witness, type: "suspect" | "witness") => {
    return (
      <div className="">
        <div className="flex flex-row mt-4 border border-[#D4D4D4] p-4 rounded-lg">
          <div className="flex flex-1 items-center gap-2">
            <img
              src={
                data?.picture_file || require("../../../images/imageVector.png")
              }
              alt="User"
              className="w-10 h-10 rounded mr-2 cursor-pointer"
              onClick={() => {
                setIsImageModalOpen(true);
                setSelectedEntity(data);
              }}
            />
            <div>
              <p className="text-gray-800 font-semibold">{`${data?.first_name} ${data?.middle_name} ${data?.last_name}`}</p>
              <div className="flex flex-row gap-1 items-center">
                <p className="text-gray-500 text-sm">{data?.age}</p>
                <p>•</p>
                <p className="text-gray-500 text-sm">{data?.phone_number}</p>
                <p>•</p>
                <p className="text-gray-500 text-sm">{data?.nationality}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center mt-4 gap-2">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setIsDetailModalOpen({
                  suspect: type === "suspect",
                  witness: type === "witness",
                });
                setSelectedEntity(data);
              }}
            >
              {viewIcon}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div className="bg-white shadow-md rounded-lg p-6">
        <div>
          <div className="bg-[#F9F9F9] px-3 py-2 rounded-lg flex flex-row items-center justify-between ">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-[#212121] text-[48px]">#</span>
              <div>
                <h4 className="text-[#212121] text-sm font-medium">
                  Court Registration Number: {file?.court_registration_number}
                </h4>
              </div>
            </div>
          </div>

          <h2 className="my-3 font-[Poppins] font-semibold text-base border-b border-[#D4D4D4] pb-2">
            About the opening case file type
          </h2>
          <div className="px-4">
            <div className="grid grid-cols-3 gap-4 w-full">
              {[
                {
                  property: "Court Registration No",
                  value: file?.court_registration_number || "N/A",
                },
                {
                  property: "Incident Registration No",
                  value: file?.incident_registration_no || "N/A",
                },
                {
                  property: "Crime Reference No",
                  value: file?.crime_refernce_number || "N/A",
                },
                {
                  property: "Prosecutor Registration No",
                  value: file?.prosecutor_registration_number || "N/A",
                },
                {
                  property: "First Court Hearing Date",
                  value: DateView(file?.first_court_hearing_date) || "N/A",
                },
                {
                  property: "Court Hearing Place",
                  value: file?.court_hearing_place || "N/A",
                },
                {
                  property: "Court Level",
                  value: file?.court_level || "N/A",
                },
                {
                  property: "Court Type",
                  value: file?.court_type || "N/A",
                },
                {
                  property: "Assign Prosecutor",
                  value: file?.assign_prosecutor || "N/A",
                },
                {
                  property: "Reassign Prosecutor",
                  value: file?.reassign_prosecutor,
                },
                {
                  property: "Status",
                  value: file?.status
                    ? OpeniningCaseFileStatus[file?.status]
                    : "N/A",
                },
              ]?.map((info, index) => {
                return (
                  info?.value && (
                    <div key={index}>
                      <p className="font-medium font-[Poppins] text-sm text-[#E90101]">
                        {info.property}
                      </p>
                      <p className="font-normal text-sm text-black">
                        {info.value}
                      </p>
                    </div>
                  )
                );
              })}
            </div>

            <p className="font-medium font-[Poppins] text-sm text-[#E90101] mt-7 mb-1">
              Court Location
            </p>
            <div className="grid grid-cols-2 gap-4 w-[500px] bg-[#F9F9F9] p-7 rounded">
              {[
                {
                  property: "City",
                  value: file?.city,
                },
                {
                  property: "Woreda",
                  value: file?.woreda,
                },
                {
                  property: "Sub City",
                  value: file?.sub_city,
                },
                {
                  property: "Zone",
                  value: file?.zone,
                },
              ]?.map((info, index) => (
                <div key={index} className="flex flex-row gap-1">
                  <p className="font-normal font-[Poppins] text-xs text-[#979797]">
                    {info.property}
                  </p>
                  <p
                    className="font-medium text-sm text-black"
                    style={{
                      overflowWrap: "break-word",
                    }}
                  >
                    : {info.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <p className="font-normal font-[Poppins] text-base text-[#432101AB]">
            Defendants List
          </p>
          <div className="bg-[#F9F9F9] px-3 py-2 rounded-lg flex flex-row items-center justify-between mt-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-[#212121] text-[48px]">#</span>
              <div>
                <h4 className="text-[#212121] text-sm font-medium">
                  Defendants
                </h4>
                <p className="text-[#A4A4A4] text-xs">
                  {file?.defendants_info?.length || 0} people
                </p>
              </div>
            </div>
          </div>
          {file?.defendants_info?.map((defendant, index) => (
            <div key={index}>{buildView(defendant, "suspect")}</div>
          ))}
        </div>
      </div>

      {isImageModalOpen && (
        <ImageModal
          isOpen={isImageModalOpen}
          imageSrc={
            selectedEntity?.picture_file ||
            require("../../../images/imageVector.png")
          }
          label={
            selectedEntity?.first_name +
            " " +
            selectedEntity?.last_name +
            " " +
            selectedEntity?.last_name
          }
          onClose={() => setIsImageModalOpen(false)}
        />
      )}
      {isDetailModalOpen?.suspect && (
        <SuspectDetailInfo
          suspect={selectedEntity as Suspect}
          isOpen={isDetailModalOpen?.suspect}
          onClose={() =>
            setIsDetailModalOpen({
              suspect: false,
              witness: false,
            })
          }
        />
      )}
    </div>
  );
};

export default CourtInfo;
